/* unplugin-vue-components disabled */import { render } from "./SearchBarSearchField.vue?vue&type=template&id=3ad7d4a4&scoped=true&ts=true"
import script from "./SearchBarSearchField.vue?vue&type=script&lang=ts"
export * from "./SearchBarSearchField.vue?vue&type=script&lang=ts"

import "./SearchBarSearchField.vue?vue&type=style&index=0&id=3ad7d4a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad7d4a4"]])

export default __exports__